import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';
import settings from '@/modules/propertyDocument/settings';
import reports from '@/modules/propertyDocument/reports';

const route: RouteObject = {
	path: 'propertyDocument',
	loader: () => ({
		meta: {
			title: 'PropertyDocument',
			to: { id: 'propertyDocumentHome' },
			htmlTitlePattern: '#title :: PropertyDocument',
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/propertyDocument/Layout')).default }),
	children: [
		{
			path: '',
			index: true,
			id: 'propertyDocumentHome',
			loader: () => ({
				meta: {
					title: 'Home',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/pages/Home')).default }),
		},
		{
			path: 'leads',
			id: 'propertyDocumentLeads',
			index: true,
			loader: () => ({
				meta: {
					title: 'Leads',
					htmlTitle: `Leads`,
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/pages/Leads')).default }),
		},
		{
			path: '',
			shouldRevalidate: () => true,
			loader: ({ params }) => ({
				meta: {
					title: params.abbreviation,
					to: { id: 'propertyDocumentStateHome', params: { abbreviation: params.abbreviation } },
				} as RouteMeta,
			}),
			children: [
				{
					path: ':abbreviation',
					id: 'propertyDocumentStateHome',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Home',
							htmlTitle: `${params.abbreviation} Home`,
							disabled: true,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/propertyDocument/pages/StateHome')).default }),
				},
				{
					path: ':abbreviation/orders',
					id: 'propertyDocumentOrders',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Orders',
							htmlTitle: `${params.abbreviation} Orders`,
							disabled: true,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/propertyDocument/pages/Orders')).default }),
				},
				{
					path: ':abbreviation/mailings',
					id: 'propertyDocumentMailings',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Mailings',
							disabled: true,
							htmlTitle: `${params.abbreviation} Mailings`,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/propertyDocument/pages/Mailings')).default }),
				},
				{
					path: ':abbreviation/entities',
					id: 'propertyDocumentEntities',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Entities',
							disabled: true,
							htmlTitle: `${params.abbreviation} Entities`,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/propertyDocument/pages/Entities')).default }),
				},
				{
					path: ':abbreviation/:entityID',
					id: 'PropertyDocumentEntityProfile',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Profile',
							disabled: true,
							htmlTitle: `${params.abbreviation} Profile`,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/propertyDocument/pages/Profile')).default }),
				},
			],
		},
		settings,
		reports,
	],
};
export default route;
